import { endpoint, remoteModifyPut } from "./utils.js";
import axios from 'axios';
import { objComparatorNumber } from "../utils.js";

export function agencyRootURL() {
  return endpoint("internal/current/agency/");
}

export async function fetchAgencys() {
  const res = await axios.get(agencyRootURL(), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id')).map(el => {
    return { ...el, visual_name: `${el['id']} - ${el['name']}` };
  });
}

export async function modifyPutAgency(useAlerts, payload, agencyId) {
  await remoteModifyPut(useAlerts, `${agencyRootURL()}${agencyId}/`, payload, 'Agency', 'Agency');
}
